module.exports = __webpack_public_path__ + "img/de.246a5fcb.svg";